var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknownContainer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / unknown container") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live-DAC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private-car-Tailgating-Copy-3",
    transform: "translate(-1529.000000, -669.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-entries",
    transform: "translate(80.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-unknown-container",
    transform: "translate(1449.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/container",
    opacity: 0.2,
    transform: "translate(2.400000, 8.800000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/container"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.99673469,2.32989474 L3.99673469,10.6891228",
    id: "Line-3",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59869388,0.817192982 L1.59869388,12.2161404",
    id: "Line-3-Copy-7",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.579102,0.817192982 L25.579102,12.2161404",
    id: "Line-3-Copy-8",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19412245,2.32989474 L7.19412245,10.6891228",
    id: "Line-3-Copy",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3915102,2.32989474 L10.3915102,10.6891228",
    id: "Line-3-Copy-2",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.588898,2.32989474 L13.588898,10.6891228",
    id: "Line-3-Copy-3",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7862857,2.32989474 L16.7862857,10.6891228",
    id: "Line-3-Copy-4",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1810612,2.32989474 L23.1810612,10.6891228",
    id: "Line-3-Copy-5",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9836735,2.32989474 L19.9836735,10.6891228",
    id: "Line-3-Copy-6",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.03619048,
    x: 0.917768707,
    y: 0.518095238,
    width: 25.3422585,
    height: 11.9434586
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.55271368e-15,12.9796491 L27.1777959,12.9796491",
    id: "Line-2",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M15.2274378,18.7760592 C15.2389151,18.0931596 15.3163857,17.5537343 15.4598521,17.1577673 C15.6033184,16.7618003 15.8959852,16.3228 16.3378615,15.8407532 L17.465501,14.6786819 C17.9475478,14.1335099 18.1885676,13.5481762 18.1885676,12.9226631 C18.1885676,12.3201046 18.030757,11.8481075 17.7151311,11.5066577 C17.3995053,11.1652079 16.94042,10.9944855 16.3378615,10.9944855 C15.7525189,10.9944855 15.2819565,11.1494268 14.9261601,11.4593141 C14.5703636,11.7692013 14.3924681,12.1852473 14.3924681,12.7074647 L12.8,12.7074647 C12.8114773,11.777803 13.1428795,11.0274855 13.7942165,10.4564896 C14.4455536,9.88549367 15.2934267,9.6 16.3378615,9.6 C17.4224668,9.6 18.2674706,9.89123224 18.8728985,10.4737054 C19.4783263,11.0561787 19.7810356,11.855274 19.7810356,12.8710155 C19.7810356,13.8752796 19.3162118,14.8651823 18.3865501,15.8407532 L17.4482851,16.7704102 C17.0293635,17.2352411 16.8199059,17.903784 16.8199059,18.7760592 L15.2274378,18.7760592 Z M15.1585743,21.5047747 C15.1585743,21.2465354 15.2374796,21.0299045 15.3952925,20.8548756 C15.5531055,20.6798467 15.786952,20.5923336 16.0968393,20.5923336 C16.4067265,20.5923336 16.6420077,20.6798467 16.80269,20.8548756 C16.9633722,21.0299045 17.0437122,21.2465354 17.0437122,21.5047747 C17.0437122,21.7630141 16.9633722,21.9767757 16.80269,22.1460659 C16.6420077,22.3153561 16.4067265,22.4 16.0968393,22.4 C15.786952,22.4 15.5531055,22.3153561 15.3952925,22.1460659 C15.2374796,21.9767757 15.1585743,21.7630141 15.1585743,21.5047747 Z",
    id: "?",
    fillOpacity: 0.54,
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownContainer);
export default __webpack_public_path__ + "static/media/unknown_container.18076fa8c64d27a9322ec816011511d0.svg";
export { ForwardRef as ReactComponent };